<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-date-picker
          v-model="table.query.startYear"
          type="year"
          placeholder="请选择年份"
          @change="getSettlementResult()"
          value-format="yyyy"
        >
        </el-date-picker>
        <div class="title mt20">收入统计</div>
        <div class="lr start" v-if="showSettlement">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
              <span class="card-title">总收：{{settlement[0].totalReceive}}</span>
            </div>
            <div class="text item">
              <span class="mr20" v-for="(member,index) in settlement[0].receiveMembers" :key="index">{{member.name}}：{{member.value}}</span>
            </div>
          </el-card>
          <el-card class="box-card ml20" shadow="hover">
            <div slot="header" class="clearfix">
              <span class="card-title">总盈利：{{parseInt(settlement[1].totalProfit)}}</span>
              <span class="des">（盈利 = 收租 + 违约金 - 房东总交 - 中介费 - 空置亏损 - 退款房租）</span>
              <span class="des">（空置亏损 ＝ 房间成本价 * 房源的n个房间年总空置总和）</span>
              <span class="des">（房间成本价 ＝ 房源月租金 ÷ 30 ÷ 房源房间数）</span>
            </div>
            <div class="text item">
              <span class="mr20">违约金：{{settlement[1].totalBreak}}</span>
              <span class="mr20">房东总交：{{settlement[1].totalOwnerCollect}}</span>
              <span class="mr20">中介费：{{settlement[1].totalAgency}}</span>
              <span class="mr20">空置亏损：{{parseInt(settlement[1].totalFree)}}</span>
              <span>退款房租：{{settlement[1].totalBack}}</span>
            </div>
          </el-card>
        </div>
        <div class="title mt20">房源明细</div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="450px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="房源" align="center"
                             prop="houseName"></el-table-column>
            <el-table-column show-overflow-tooltip label="盈利" align="center"
                             prop="totalProfit">
              <template slot-scope="scope">
                <span>{{parseInt(scope.row.totalProfit)}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="收租" align="center"
                             prop="totalReceive"></el-table-column>
            <el-table-column show-overflow-tooltip label="违约金" align="center"
                             prop="totalBreak"></el-table-column>
            <el-table-column show-overflow-tooltip label="房东总交" align="center"
                             prop="totalOwnerCollect"></el-table-column>
            <el-table-column show-overflow-tooltip label="中介费" align="center"
                             prop="totalAgency"></el-table-column>
            <el-table-column show-overflow-tooltip label="空置亏损" align="center"
                             prop="totalFree">
              <template slot-scope="scope">
                <span>{{parseInt(scope.row.totalFree)}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="退款房租" align="center"
                             prop="totalBack">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {settlement} from "@/api/house";

export default {
  data() {
    return {
      table: {
        query: {
          startYear: ''
        },
        data: []
      },
      settlement: [],
      actualMonth: [],
      showSettlement: false,
      tableLoading: false,
      startYear: ''
    }
  },
  mounted() {
    this.table.query.startYear = new Date().getFullYear() + ''
    this.getSettlementResult()
  },
  methods: {
    getSettlementResult() {
      settlement(this.table.query).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.settlement = response.data
          this.showSettlement = true
          this.table.data = this.settlement[2].settlements
        }
      })
    }
  }
}
</script>

<style scoped>
.card-title {
  font-weight: bolder;
}

.des {
  color: red;
}

.el-card__header {
  background: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/views/back/backSettlement.vue